import { AppDrawer } from '@components/AppDrawer'
import type { ParentProps } from 'solid-js'
import { useService } from 'solid-services'
import { Box, Grid } from 'styled-system/jsx'
import Create from './Create'
import { useCreate } from './Create/state'
import List from './List'
import Single from './Single'


function Container(props: ParentProps) {
  const { isCreateOpen, setIsCreateOpen, isEditing, chartPanelEl } = useService(useCreate)()
  return (
    <Grid gridTemplateRows='auto 1fr' gap={0}>
      {props.children}

      <AppDrawer
        size='xl'
        open={isCreateOpen()}
        onOpenChange={({ open }) => setIsCreateOpen(open)}
        title={isEditing() ? 'Edit Setup' : 'Publish Setup'}
        persistentElements={[() => chartPanelEl()]}
      >
        <Create />
      </AppDrawer>
    </Grid>
  )
}

const routes = [
  {
    path: '/setups',
    component: Container,
    children: [
      {
        path: '/',
        component: List,
      },
      {
        path: '/:id',
        component: Single,
      }
    ],
  },
]

export default routes
